<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 9H19.8288C20.8047 9 21.5207 9.91708 21.284 10.8638L19.034 19.8638C18.8671 20.5316 18.2671 21 17.5788 21H4.5C3.67157 21 3 20.3284 3 19.5V12C3 11.1716 3.67157 10.5 4.5 10.5H7.5L10.5 3H13.5C14.3284 3 15 3.67157 15 4.5V9ZM7.5 12H4.5V19.5H7.5V12Z" fill="currentColor"/>
  </svg>
</template>